<template>
  <b-card no-body class="c--customer-reviews_item" :class="`${classPrefix}-box review-item`">
    <b-card-header
      header-tag="div"
      class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center flex-wrap"
    >
      <div
        class="d-flex flex-column flex-md-row justify-content-start align-items-start align-items-md-center mb-2 mb-md-0"
      >
        <raiting
          :value="item.rating"
          :width="22"
          :color="['#FBB034', '#FFCC00']"
          :unrated-color="['#DDDDDD', '#DDDDDD']"
          class="mb-2 mb-md-0"
        />
        <country-name-in-flag
          :country-flag-url="item.country.image.url"
          :country-flag-width="29"
          :country-name="item.country.title"
          class=""
          :class="{
            'ml-0 ml-md-2': $dir() === 'ltr',
            'mr-0 mr-md-2': $dir() === 'rtl',
          }"
        />
      </div>
      <div class="d-flex justify-content-start align-items-center">
        <header-right :reviewer="item.customer_name" />
      </div>
    </b-card-header>

    <b-card-body>
      <div class="d-flex justify-content-start align-items-start w-full flex-col flex-wrap">
        <div class="w-100">
          <h3-title :title="item.title" :class="{ 'one-line-text': textCollapsed }" />
        </div>
        <div>
          <less-more-text
            :text="item.content"
            :button-more-text="$t('components.customer.reviews.more-button')"
            :button-less-text="$t('components.customer.reviews.less-button')"
            :close="closeLessMore"
            :is-less-more-prevent="isLessMorePrevent"
            @changeCollapse="changeCollapse"
          />
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>
<script>
  import Raiting from '~/components/shared/raiting.vue'
  import CountryNameInFlag from '~/components/shared/country-name-in-flag.vue'
  import HeaderRight from '~/components/customer-reviews/header-right.vue'
  import H3Title from '~/components/shared/h3-title.vue'
  import LessMoreText from '~/components/shared/less-more-text.vue'

  export default {
    components: {
      Raiting,
      CountryNameInFlag,
      HeaderRight,
      H3Title,
      LessMoreText,
    },
    props: {
      classPrefix: {
        type: String,
        required: false,
        default: 'card-box-1',
      },
      item: {
        type: Object,
        required: true,
      },
      closeLessMore: {
        type: Boolean,
        required: false,
        default: true,
      },
      isLessMorePrevent: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        textCollapsed: true,
      }
    },
    methods: {
      changeCollapse(collapsed) {
        this.textCollapsed = collapsed

        this.$emit('activeCollapsed', this.textCollapsed)
      },
    },
  }
</script>
<style lang="scss" scoped>
  .card {
    &.review-item {
      border-radius: 7px;
      background-color: #ffffff;
      box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.15);
      border: none;
      width: 100%;

      .card-header {
        border-radius: 0;
        background-color: unset;
        padding: 20px;
        border: none;
      }

      .card-body {
        padding: 3px 20px 20px;

        .one-line-text {
          width: 100%;

          ::v-deep {
            h3 {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
</style>
